<template>
  <support-shortend-message-cell
    :content="model.payload || ''"
    v-if="isDescription"
  ></support-shortend-message-cell>
  <media-cell
    v-else-if="content"
    :model="content"
    :content="content.url"
  ></media-cell>
  <td v-else></td>
</template>

<script>
import MediaCell from "@/components/table/MediaCell.vue";
import SupportShortendMessageCell from "@/components/table/SupportShortendMessageCell.vue";

export default {
  components: {
    MediaCell,
    SupportShortendMessageCell
  },
  props: ["content", "model"],
  computed: {
    isDescription() {
      return this.model.reviewable_type === "App\\CustomerProfile";
    }
  }
};
</script>

<style></style>
